// Config
import endpoints from '@/config/endpoints'
import { domainToLocaleMap } from '@/config'
import {
  DEFAULT_CRM_BASE_URL,
  DEFAULT_CDA_OPTIN_USER_IDS,
} from '@/config/cdaOptIn'

// Types
import { Domain, Locale } from '@/types'
type Env = typeof window.env

async function setEnvFile() {
  // Get default values
  const env: Env = getDefaultEnvValues()

  // Override values from deployed /account/config/env (not used by vue-cli dev server)
  if (process.env.NODE_ENV !== 'production') {
    window.env = env
    return
  }

  try {
    const response = await fetch(endpoints.env)
    if (response.ok) {
      const data = await response.text()
      // Parse the .env file
      const lines = data.split('\n')
      for (const line of lines) {
        const [key, value] = line.split('=')
        if (key && value) {
          (env as any)[key.trim()] = value.trim().replaceAll('"', '')
        }
      }
    }
  } catch (err) {
    console.error('Error:', err)
  }

  if (typeof window !== 'undefined' && window.location?.hostname?.endsWith('yoonly.eu')) {
    env.VUE_APP_MENU_DOMAIN = window.location?.hostname as Domain;
    switch (window.location?.hostname) {
      case 'www.benl.yoonly.eu':
      case 'www.nl.yoonly.eu':
        env.VUE_APP_LOCALE = 'nl-NL'
        break
      default:
        env.VUE_APP_LOCALE = 'fr-FR'
        break
    }
  }
  // For dev only
  // else if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
  //   env.VUE_APP_MENU_DOMAIN = 'www.nl.yoonly.eu'
  //   env.VUE_APP_LOCALE = 'nl-NL'
  // }

  window.env = env
}

// Get default env values

function getDefaultEnvValues(): Env {
  const isLocalDev = process.env.NODE_ENV !== 'production'

  const env: Env = {
    VUE_APP_LOCALE: 'fr-FR',
    VUE_APP_MENU_DOMAIN: 'www.travelski.com',
    VUE_APP_CRM_BASE_URL: process.env.VUE_APP_CRM_BASE_URL || DEFAULT_CRM_BASE_URL,
    VUE_APP_CDA_OPTIN_USER_IDS:
      process.env.VUE_APP_CDA_OPTIN_USER_IDS || DEFAULT_CDA_OPTIN_USER_IDS,
  }

  const host = window.location.host as Domain
  const locale: Locale = domainToLocaleMap[host]

  // If we find the locale based on the domain, it means the domain and locale are valid, so set the values
  if (locale) {
    env.VUE_APP_LOCALE = locale
    env.VUE_APP_MENU_DOMAIN = host
  }

  // Set to locale values if needed
  if (isLocalDev) {
    env.VUE_APP_MENU_DOMAIN =
      process.env.VUE_APP_MENU_DOMAIN || 'www.travelski.com'
    env.VUE_APP_LOCALE = process.env.VUE_APP_LOCALE || 'fr-FR'
    env.VUE_APP_CDA_OPTIN_USER_IDS =
      process.env.VUE_APP_CDA_OPTIN_USER_IDS || DEFAULT_CDA_OPTIN_USER_IDS
  }

  return env
}

export default setEnvFile
